<div class="stress_gauge_section">
    <div
        class="max-value"
        [style.width.%]="100 - istress.Max_percentage"
        [style.left.%]="istress.Max_percentage"
        *ngIf="istress.Max_percentage !== 0"
        #tooltip="matTooltip"
        matTooltip="Max : {{ istress.Max_percentage }}%"
        [matTooltipPosition]="tooltip_position"
    ></div>
    <div
        class="min2seal-value"
        [style.width.%]="istress.Min2Seal_percentage"
        #tooltip="matTooltip"
        matTooltip="Min2Seal : {{ istress.Min2Seal_percentage }}%"
        [matTooltipPosition]="tooltip_position"
        *ngIf="istress.Min2Seal_percentage"
    ></div>
    <div
        class="Residual"
        [style.width.%]="istress.Residual_percentage"
        #tooltip="matTooltip"
        matTooltip="Residual : {{ istress.Residual_percentage }}%"
        [matTooltipPosition]="tooltip_position"
        *ngIf="istress.Residual_percentage"
    >
        <div [class.residual_text]="istress.Residual_percentage < 20">{{ istress.Residual_percentage }}%</div>
    </div>
    <div
        class="applied_value1"
        [style.left.%]="istress.applied1_percentage"
        *ngIf="istress.applied1_percentage"
        #tooltip="matTooltip"
        matTooltip="Applied 1 : {{ istress.applied1_percentage }}%"
        [matTooltipPosition]="tooltip_position"
    ></div>
    <div
        class="applied_value2"
        [style.left.%]="istress.applied2_percentage"
        *ngIf="istress.applied2_percentage"
        #tooltip="matTooltip"
        matTooltip="Applied 2 : {{ istress.applied2_percentage }}%"
        [matTooltipPosition]="tooltip_position"
    ></div>
    <div
        class="applied_value3"
        [style.left.%]="istress.applied3_percentage"
        *ngIf="istress.applied3_percentage"
        #tooltip="matTooltip"
        matTooltip="Applied 3 : {{ istress.applied3_percentage }}%"
        [matTooltipPosition]="tooltip_position"
    ></div>
</div>
<div class="row mt-2 mb-2" style="width: 100%; margin: 0 auto">
    <div class="col-xl-3 col-lg-6 col-md-6 col-3 minseal_yellow" *ngIf="istress.Min2Seal_percentage">
        <p>Min2Seal</p>
        <div class="line_yellow"></div>
        <p>
            {{ istress.Min2Seal_percentage }}% <span>{{ valObj.Min2Seal_value }}</span>
        </p>
    </div>
    <div class="col-xl-3 col-lg-6 col-md-6 col-3 applied_angle" *ngIf="istress.applied1_percentage">
        <div>
            <p>Applied</p>
            <div class="line_angle"></div>
            <p>
                <ng-container *ngIf="istress.applied1_percentage">{{ istress.applied1_percentage }}%</ng-container><span>{{ valObj.applied1_value }}</span>
            </p>
            <p>
                <ng-container *ngIf="istress.applied2_percentage">{{ istress.applied2_percentage }}%</ng-container><span>{{ valObj.applied2_value }}</span>
            </p>
            <p>
                <ng-container *ngIf="istress.applied3_percentage">{{ istress.applied3_percentage }}%</ng-container> <span>{{ valObj.applied3_value }}</span>
            </p>
        </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-md-6 col-3 residual_black" *ngIf="istress.Residual_percentage">
        <p>Residual</p>
        <div class="line_black"></div>
        <p>
            {{ istress.Residual_percentage }}% <span>{{ valObj.Residual_value }}</span>
        </p>
    </div>
    <div class="col-xl-3 col-lg-6 col-md-6 col-3 max_red" *ngIf="istress.Max_percentage">
        <p>Max</p>
        <div class="line_red"></div>
        <p>
            {{ istress.Max_percentage }}% <span>{{ valObj.Max_value }}</span>
        </p>
    </div>
</div>
